import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { OrderOptionApi, UpdateMultiOrderOptionsBuyOrderIDBody } from 'api';

export const updateMultiOrderOptionsBuyOrderID = createAsyncThunk(
  'orderOption/updateMultiOrderOptionsBuyOrderID',
  async (body: UpdateMultiOrderOptionsBuyOrderIDBody, { rejectWithValue }) => {
    try {
      const response = await OrderOptionApi.updateMulti(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  list: Array<any>;
}

const initialState: State = {
  list: [],
};

const orderOptionSlice = createSlice({
  name: 'orderOption',
  initialState,
  reducers: {},
  extraReducers: {},
});

const { reducer: orderOptionReducer } = orderOptionSlice;

export default orderOptionReducer;
